// extracted by mini-css-extract-plugin
export var hidden = "SimpleAccordion-module--hidden--11VMh";
export var show = "SimpleAccordion-module--show--3hK2t";